import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addassettype',
  templateUrl: './addassettype.component.html',
  styleUrls: ['./addassettype.component.css']
})
export class AddassettypeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: string = "AssetType";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  assettypeColl: any = [];
  assettypeBO: any = {};
  assettypeid: number = 0

  assettypeform = new FormGroup({
    assettypeid: new FormControl(0),
    assettype: new FormControl('', Validators.required),
    assetstartno: new FormControl(null),
    assetprefix: new FormControl(''),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.assettypeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.assettypeform.reset();
      this.fnInitializeFormGroup();

      if (this.assettypeid > 0) {
        this.fngetAssetType();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.assettypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.assettypeform.setValue({
      assettypeid: 0,
      assettype: '',
      assetstartno: null,
      assetprefix: '',
      inactive: false
    })
  }

  //Get 
  fngetAssetType() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'assettypeid': this.assettypeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAssetType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.assettypeColl = res.json().result;
            var editdata = this.assettypeColl[0];
            this.fnEditMode(editdata);
            this.assettypeBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    }
    
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.assettypeform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'assettypeid': this.assettypeid,
          'assettype': this.assettypeform.get('assettype').value,
          'assetstartno': this.assettypeform.get('assetstartno').value,
          'assetprefix': this.assettypeform.get('assetprefix').value,
          'inactive': this.assettypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAssetType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.assettypeform.get('assettypeid').value > 0) {
                  //Update 
                  this.fnSetAssetType(data);
                }
                else {
                  //Insert 
                  this.fnInsertAssetType(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.assettypeform.controls['assettype'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAssetType(data) {

    this.appService.fnInsertAssetType(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new assettype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.assettypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAssetType(data) {

    this.appService.fnSetAssetType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The assettype has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.assettypeid, data.assettypename);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/AssetType']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.assettypeform.setValue({
      assettypeid: deptBO.assettypeid,
      assettype: deptBO.assettype,
      assetstartno: deptBO.assetstartno,
      assetprefix: deptBO.assetprefix,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
